import { query, onSnapshot, where } from 'firebase/firestore'
import {
  paymentsCollGroup
} from '@/firebase-firestore'
import type { Payment } from '@/types'
import { paymentConverter } from '@/utils/record-converter'
import {
  isBefore,
  isSameDay,
  startOfDay,
  endOfDay
} from 'date-fns'
import { mapGetters } from 'vuex'
export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    historyListener: null,
    history: null
  },
  mutations: {
    setHistory (state: any, arr: []) {
      state.history = arr
    },
    setHistoryListener (state: any, listener: number) {
      state.historyListener = listener
    }
  },
  getters: {
    isHistoryReady: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return Array.isArray(rootState.products.products) && Array.isArray(state.history)
    },
    history: (state: any, getters: any, rootState: any, rootGetters: any) => {
      return getters.isHistoryReady
        ? state.history
          .map((row: Payment) => {
            if (!row.record.categorieId && row.record.productId) { // can be removed later
              const product = rootGetters['products/getProduct'](row.record.productId)
              const categorieId = row.record.categorieId || product.categorieId
              row.record.categorieId = categorieId
            }
            if (!isSameDay(row.record.dateStart, row.record.dateEnd)) {
              row.record.interval = {
                start: startOfDay(row.record.dateStart),
                end: endOfDay(row.record.dateEnd)
              }
            }
            return row
          })
        : []
    }
  },
  actions: {
    releaseHistory ({ commit, state }: { commit: any, state: any }) {
      if (state.historyListener) {
        state.historyListener()
        commit('setHistoryListener', null)
        console.warn('Removed listener for history')
      }
    },
    getHistory ({ commit, state, dispatch }: { commit: any, state: any, dispatch: any }, interval: Interval) {
      if (state.historyMinDate && !isBefore(interval.start, state.historyMinDate)) {
        return
      }
      if (state.historyListener) {
        dispatch('releaseHistory')
      }
      console.warn('getHistory', interval)
      console.time('getHistory')
      const q = query(
        paymentsCollGroup,
        where('dateCreated', '>=', interval.start),
        where('dateCreated', '<=', interval.end)
      )
      const listener = onSnapshot(q, { includeMetadataChanges: true }, async (snapshot) => {
        if (snapshot.metadata.fromCache) {
          return
        }
        if (!state.history) {
          console.timeEnd('getHistory')
        }
        console.time('getHistory.onSnapshot')
        const rows: Payment[] = []
        snapshot.forEach((doc) => {
          const recordRef = doc.ref.parent.parent
          const recordId = recordRef?.id
          if (recordId) {
            const row = doc.data()
            rows.push(paymentConverter.fromFirestore({
              id: doc.id,
              recordId,
              ...row
            }))
          }
        })
        commit(
          'setHistory',
          rows
        )
        console.timeEnd('getHistory.onSnapshot')
      })
      commit('setHistoryListener', listener)
    }
  }
}
